export const SHOW_INSTAGRAM_EMAIL_MODAL = 'SHOW_INSTAGRAM_EMAIL_MODAL'
export const CLOSE_INSTAGRAM_EMAIL_MODAL = 'CLOSE_INSTAGRAM_EMAIL_MODAL'
export const UPDATE_INSTAGRAM_EMAIL_FIELD = 'UPDATE_INSTAGRAM_EMAIL_FIELD'

export const showInstagramEmailModal = (token) => ({
	type: SHOW_INSTAGRAM_EMAIL_MODAL,
	token: token
})

export const closeInstagramEmailModal = () => ({
  type: CLOSE_INSTAGRAM_EMAIL_MODAL
})

export const updateField = (name, value) => ({
	type: UPDATE_INSTAGRAM_EMAIL_FIELD,
	name: name,
	value: value
})



// WEBPACK FOOTER //
// ./src/actions/instagramEmail.js